import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useFraudModeForm } from './hook';
import { FraudModeData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    FRAUD_MODE,
    FRAUD_MODE_DETAIL,
    FRAUD_MODE_EDIT,
    FRAUD_MODE_NEW,
} from '../../../../../routes/paths';
import { FraudModeParamsHistorical } from '../historical';

export const FraudModeForm = () => {
    const {
        fraudMode,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikFraudModeData,
        fraudModeHistorical,
        showHistorical,
        setShowHistorical,
    } = useFraudModeForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    fraudMode && fraudMode.id
                        ? 'Editar modalidad fraude'
                        : 'Crear modalidad fraude'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={fraudMode?.id || ''}
                        buttonCreate={{
                            show: Boolean(fraudMode?.id),
                            route: FRAUD_MODE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FRAUD_MODE,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: FRAUD_MODE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: FRAUD_MODE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(fraudMode?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <FraudModeParamsHistorical
                        historical={fraudModeHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <FraudModeData
                data={fraudMode}
                onChangeFormik={(formik) => setFormikFraudModeData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
